const CD_DIRIGENTE_TI = 'DT';
const DIRIGENTE_TI = {
	codigo: CD_DIRIGENTE_TI,
	nome: 'Dirigente de TI'
}

const CD_RESPONSÁVEL_TECNICO = 'RT';
const RESPONSAVEL_TECNICO = {
	codigo: CD_RESPONSÁVEL_TECNICO,
	nome: 'Responsável Técnico'
}

const CD_PONTO_FOCAL = 'PF';
const PONTO_FOCAL = {
	codigo: CD_PONTO_FOCAL,
	nome: 'Ponto Focal'
}

export {CD_DIRIGENTE_TI, CD_RESPONSÁVEL_TECNICO, CD_PONTO_FOCAL, DIRIGENTE_TI, RESPONSAVEL_TECNICO, PONTO_FOCAL}
